import "core-js/modules/web.dom.iterable";
import _defineProperty from "/var/lib/jenkins/workspace/yesep-ui/node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js";
//
//
//
//
//
import echarts from 'echarts';
import 'echarts/lib/chart/gauge';
import 'echarts/lib/component/tooltip';
import 'echarts/lib/component/title';
import { queryJobOrderAnalysis } from '@/api/api';
export default {
  props: {
    width: {
      type: String,
      default: '450px'
    },
    height: {
      type: String,
      default: '280px'
    },
    top: {
      type: String,
      default: '30px'
    },
    position: {
      type: String,
      default: 'absolute'
    },
    left: {
      type: String,
      default: '0px'
    },
    marginLeft: {
      type: String,
      default: '0px'
    },
    type: {},
    id: {},
    queryType: {}
  },
  data: function data() {
    return {
      chart: 'chart10'
    };
  },
  watch: {
    id: {
      handler: function handler(val) {
        this.querySewageQuotaList(this.type, val, this.queryType);
      },
      immediate: true
    },
    queryType: function queryType(val) {
      this.querySewageQuotaList(this.type, this.id, val);
    }
  },
  methods: {
    initBarChart: function initBarChart(data) {
      var option = _defineProperty({
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'

          }
        },
        legend: {
          data: data.legendData,
          top: '5%',
          textStyle: {
            color: 'rgba(55,255,249,1)'
          }
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: [{
          type: 'category',
          data: data.xData,
          splitLine: {
            show: false
          },
          axisLine: {
            lineStyle: {
              color: 'rgba(55,255,249,1)'
            }
          },
          axisLabel: {
            color: 'rgba(55,255,249,1)'
          }
        }],
        yAxis: [{
          type: 'value',
          splitLine: {
            show: false
          },
          axisLine: {
            lineStyle: {
              color: 'rgba(55,255,249,1)'
            }
          }
        }],
        series: data.seriesData
      }, "tooltip", {
        show: true
      });

      var chart = this.$refs[this.chart];
      var myChart = this.$echarts.init(chart);
      myChart.setOption(option);
      window.addEventListener('resize', function () {
        myChart.resize();
      }, false);
    },
    // 趋势数据
    querySewageQuotaList: function querySewageQuotaList(type, id, queryType) {
      var _this = this;

      queryJobOrderAnalysis({
        type: type,
        id: id,
        queryType: queryType
      }).then(function (res) {
        if (res.success) {
          var data1 = [],
              data2 = [],
              data3 = [];
          var data = {
            xData: [],
            seriesData: [],
            legendData: ['一般任务', '较大任务', '重大任务']
          };
          res.result.forEach(function (v, i) {
            data.xData.push(v.dateStr);
            data1.push(v.commonlyNum);
            data2.push(v.largerNum);
            data3.push(v.majorNum);
          });
          data.seriesData = [{
            name: '一般任务',
            type: 'bar',
            barWidth: 20,
            itemStyle: {
              barBorderRadius: 20,
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                offset: 0,
                color: "rgba(55,255,249,1)"
              }, {
                offset: 1,
                color: "rgba(0,222,215,0.2)"
              }])
            },
            data: data1
          }, {
            // 替代柱状图 默认不显示颜色，是最下方柱图（邮件营销）的value值 - 20
            type: 'bar',
            barWidth: 20,
            barGap: '-100%',
            stack: '工单',
            itemStyle: {
              color: 'transparent'
            },
            data: data1
          }, {
            name: '较大任务',
            type: 'bar',
            barWidth: 20,
            barGap: '-100%',
            stack: '工单',
            itemStyle: {
              barBorderRadius: 20,
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                offset: 0.4,
                color: "rgba(255,252,0,1)"
              }, {
                offset: 1,
                color: "rgba(8,228,222,0.2)"
              }])
            },
            data: data2
          }, {
            // 替代柱状图 默认不显示颜色，是最下方柱图（邮件营销）的value值 - 20
            type: 'bar',
            barWidth: 20,
            barGap: '-100%',
            stack: '工单',
            itemStyle: {
              color: 'transparent'
            },
            data: data3
          }, {
            name: '重大任务',
            type: 'bar',
            barWidth: 20,
            barGap: '-100%',
            stack: '工单',
            itemStyle: {
              barBorderRadius: 20,
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                offset: 0.4,
                color: "orange"
              }, {
                offset: 1,
                color: "yellow"
              }])
            },
            data: data3
          }];

          _this.initBarChart(data);
        }
      });
    }
  }
};